import styled from "styled-components";

export const MainContainer = styled.div`
  margin: 16px 16px 28px 16px;
`;
